export class AiChatUserInput {
  constructor ({
    type,
    message,
    streamId,
    oldStreamId
  }) {
    this.type = type
    this.message = message
    this.streamId = streamId
    this.oldStreamId = oldStreamId
  }
}
